module.exports = __webpack_public_path__ + "static/media/ic-logo.90a9a852.svg";